import React from 'react'
import { Close } from '@mui/icons-material';

const TermsAndConditions = ({ isOpen, onClose, children }) => {
  if (!isOpen) return null;
  return (
    <div className="modal-overlay">
      <div className="modal-content">
        <Close className="modal-close" onClick={onClose} />
        {children}
      </div>
    </div>
  )
}

export default TermsAndConditions